export default "__VITE_ASSET__C40niWtV__"